import {
  isArray, isString, findIndex, isEmpty,
} from 'lodash';
import { baseUrl } from '@sda/utils/url';
import { getUploadHash } from '../crypto';
import type { PublicImageUrl } from '@sda/interfaces/image';

export const getImageArrayFromField = (images: string | PublicImageUrl[] | string[], fallback?: string): PublicImageUrl[] => {
  let imageArray = [];

  if (isEmpty(images) && fallback) {
    imageArray = [{
      path: baseUrl(fallback),
      updatedAt: null,
      hash: 'fallback',
      id: 'fallback',
    }];
  } else if (isString(images)) {
    imageArray = [{
      path: images,
      updatedAt: null,
      hash: 'stringImage',
      id: 'stringImage',
    }];
  } else if (isArray(images) && images.length) {
    imageArray = [...images];

    if (typeof images[0] !== 'string') {
      const coverIndex = findIndex(images as PublicImageUrl[], (image) => image.isCover === true);

      if (coverIndex !== -1) {
        // For legacy image arrays, extract the cover image and push it to the front of the array
        imageArray.unshift(imageArray.splice(coverIndex, 1)[0]);

        return imageArray.map((image) => {
          let { hash } = image;

          if (!hash) {
            hash = getUploadHash(image.path);
          }

          return {
            hash,
            path: image.path,
            updatedAt: image.updatedAt || new Date(),
            id: image.id || hash,
          };
        });
      }

      return imageArray.map((image) => {
        let { hash } = image;

        if (!hash) {
          hash = getUploadHash(image.path);
        }

        return {
          ...image,
          hash,
          id: image.id || hash,
        };
      });
    }

    const updatedAt = new Date();

    return imageArray.map((image: string) => {
      const hash = getUploadHash(image);

      return {
        hash,
        updatedAt,
        id: hash,
        path: image,
      };
    });
  }

  return imageArray;
};
